/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SmartProblemDetails,
  UserBudgetReadModel,
  UserPermissionsDto,
} from '../models/index';
import {
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
    UserBudgetReadModelFromJSON,
    UserBudgetReadModelToJSON,
    UserPermissionsDtoFromJSON,
    UserPermissionsDtoToJSON,
} from '../models/index';

/**
 * 
 */
export class UsersCurrentApi extends runtime.BaseAPI {

    /**
     */
    async usersCurrentBudgetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserBudgetReadModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/users/current/budget`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserBudgetReadModelFromJSON(jsonValue));
    }

    /**
     */
    async usersCurrentBudget(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserBudgetReadModel> {
        const response = await this.usersCurrentBudgetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async usersCurrentGetPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserPermissionsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/users/current/permissions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPermissionsDtoFromJSON(jsonValue));
    }

    /**
     */
    async usersCurrentGetPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserPermissionsDto> {
        const response = await this.usersCurrentGetPermissionsRaw(initOverrides);
        return await response.value();
    }

}
